import React from "react";
import { Column } from "react-table";
import Svg from "components/common/SVG/Svg";
import { IFeatureData } from "components/features/types";

type TProps = {
  handleCheckboxAction: (
    entity: IFeatureData,
    id: string,
    rowVersion: string,
    isEnabled: boolean,
  ) => Promise<void> | null;
  onEditConfig: (entity: IFeatureData) => void;
};

const FeaturesManagementTableColumns = ({ onEditConfig }: TProps) => {
  const renderBoolean = (value: boolean) => (
    <span className={`small ${value ? "text-success" : "text-muted"}`}>{value ? "Yes" : "No"}</span>
  );

  const checkStatus = (isActive: boolean): string => (isActive ? "Active" : "Inactive");
  const checkLabelStatus = (isActive: boolean): string => (isActive ? "success" : "danger");

  return React.useMemo(
    () =>
      [
        {
          Header: "Name",
          accessor: "name",
          disableSortBy: true,
          Cell: ({ value }: any) => <span className="fw-medium text-dark">{value}</span>,
        },
        {
          Header: "Allowed to use",
          accessor: "configuration",
          disableSortBy: true,
          Cell: ({ value }: any) => renderBoolean(value),
        },
        {
          Header: "Active",
          accessor: "isEnabled",
          disableSortBy: true,
          Cell: ({ value }: any) => (
            <div className="text-center">
              <span className={`badge bg-${checkLabelStatus(value)}`}>{checkStatus(value)}</span>
            </div>
          ),
        },
        {
          Header: "Type",
          accessor: "capabilities",
          disableSortBy: true,
          Cell: ({ row }: any) => {
            const { configuration } = row.original;

            if (configuration?.type) {
              return configuration?.type;
            }
            return "-";
          },
        },
        {
          Header: "Configuration",
          accessor: "configName",
          disableSortBy: true,
          Cell: ({ value, row }: any) => {
            const { capabilities, configuration } = row.original;
            const supportsSharedConfig = !capabilities?.includes("CanUseSharedConfigurations");

            if (value) {
              return value;
            }

            if (supportsSharedConfig || configuration?.type === "Tenant") {
              return "By Tenant";
            }

            return "No";
          },
        },
        {
          Header: "Actions",
          accessor: "actions",
          disableSortBy: true,
          Cell: ({ row }: any) => {
            const { original } = row;
            const { id } = original;

            return (
              <div className="text-center">
                <div className="dropdown">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    id={`tenantActionDropdown_${id}`}
                  >
                    {Svg({ icon: "threeDots", width: 20, height: 20 })}
                  </button>
                  <ul className="dropdown-menu" aria-labelledby={`tenantActionDropdown_${id}`}>
                    <li>
                      <button
                        type="button"
                        className="dropdown-item"
                        onClick={() => onEditConfig(original)}
                      >
                        <Svg icon="pencil" width={15} height={15} />
                        <span className="ms-2">Edit</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            );
          },
        },
      ] as Column<object>[],
    [onEditConfig],
  );
};

export default FeaturesManagementTableColumns;
